import { render, staticRenderFns } from "./an-content-header.vue?vue&type=template&id=0c565c84"
import script from "./an-content-header.vue?vue&type=script&lang=js"
export * from "./an-content-header.vue?vue&type=script&lang=js"
import style0 from "./an-content-header.vue?vue&type=style&index=0&id=0c565c84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports